/* eslint-disable new-cap */
import {defineCustomElement} from 'extensions/utils';
import {html} from 'lit';
import {ProductListing} from '../product-listing/product-listing';
import styles from './setting-product-listing.component.scss?as=stylesheet';

class SettingProductListing extends ProductListing {
	static get styles () {
		return [
			...super.styles,
			styles
		];
	}

	constructor () {
		super();
	}

	get compareActive () {
		return this.store?.setting?.compareListActive;
	}

	renderResult (result) {
		if (result?.type === 'inline-banner') {
			return this.renderInlineBanner(result.content);
		}

		return html`<rb-setting-card .store="${this.store}" .result="${result}" class="o-layout__item setting-product-listing--item"></rb-setting-card>`;
	}

	renderResults () {
		return html`<div class="setting-product-listing--items o-layout u-grids-3--m u-grids-2">
			${this.service?.store?.state?.results?.map(result => this.renderResult(result))}
		</div>`;
	}

	renderCompare () {
		return html`<div class="setting-product-listing--items o-layout u-grids-3--m u-grids-2">
			${this.compareList?.map(result => this.renderResult(result))}
		</div>`;
	}
}

defineCustomElement('rb-setting-product-listing', SettingProductListing);
